// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.authLayout_auth_wrapper__INM\\+y {
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.authLayout_left_panel__Cr0ku {
  flex: 1 1;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: flex-end;
  padding: 40px;
  color: var(--color-white-500);
  font-size: 4rem;
  font-weight: bold;
}
@media only screen and (max-width: 810px) {
  .authLayout_left_panel__Cr0ku {
    display: none;
  }
}

.authLayout_right_panel__u2TVO {
  flex: 1 1;
  background-color: var(--bg-color);
}
@media only screen and (max-width: 810px) {
  .authLayout_right_panel__u2TVO {
    flex: 1 1 100%;
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 24px 16px;
  }
}

.authLayout_logo_top__DQ3xE {
  position: absolute;
  top: 32px;
  right: 32px;
  height: 32px;
}
@media only screen and (max-width: 450px) {
  .authLayout_logo_top__DQ3xE {
    top: 16px;
    right: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/modules/AuthLayout/authLayout.module.scss","webpack://./src/assets/scss/_breakpoint.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AADF;;AAIA;EACE,SAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,qBAAA;EACA,aAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;AADF;ACJE;EDJF;IAYI,aAAA;EAAF;AACF;;AAGA;EACE,SAAA;EACA,iCAAA;AAAF;ACdE;EDYF;IAKI,cAAA;IACA,WAAA;IACA,aAAA;IACA,gBAAA;IACA,uBAAA;IACA,2BAAA;IACA,kBAAA;EACF;AACF;;AACA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AAEF;AC5CE;EDsCF;IAOI,SAAA;IACA,WAAA;EAGF;AACF","sourcesContent":["@use \"../../../assets/scss/breakpoint\" as *;\n\n.auth_wrapper {\n  display: flex;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.left_panel {\n  flex: 1;\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  align-items: flex-end;\n  padding: 40px;\n  color: var(--color-white-500);\n  font-size: 4rem;\n  font-weight: bold;\n\n  @include tablet {\n    display: none;\n  }\n}\n\n.right_panel {\n  flex: 1;\n  background-color: var(--bg-color);\n\n  @include tablet {\n    flex: 1 1 100%;\n    width: 100%;\n    height: 100vh;\n    overflow-y: auto;\n    align-items: flex-start;\n    justify-content: flex-start;\n    padding: 24px 16px;\n  }\n}\n.logo_top {\n  position: absolute;\n  top: 32px;\n  right: 32px;\n  height: 32px;\n\n  @include mobile {\n    top: 16px;\n    right: 16px;\n  }\n}\n","@mixin mobile {\n  @media only screen and (max-width: 450px) {\n    @content;\n  }\n}\n\n@mixin mobileH {\n  @media only screen and (max-height: 710px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: 810px) {\n    @content;\n  }\n}\n\n@mixin middle {\n  @media only screen and (max-width: 576px) {\n    @content;\n  }\n}\n\n@mixin middleTablet {\n  @media only screen and (max-width: 780px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"auth_wrapper": `authLayout_auth_wrapper__INM+y`,
	"left_panel": `authLayout_left_panel__Cr0ku`,
	"right_panel": `authLayout_right_panel__u2TVO`,
	"logo_top": `authLayout_logo_top__DQ3xE`
};
export default ___CSS_LOADER_EXPORT___;
